import React from 'react';
import Immutable from 'immutable';

import LookupInput from './lookupinput';
import { triggerActionEvent } from './common';
import { getNextAutoFocusId } from './autofocus';
import { isEmpty } from '../../data/validation';

const EMPTY_LIST = Immutable.List([]);

function maxNumber(val1, val2) {
	if (typeof val1 === 'number') {
		if (typeof val2 === 'number') {
			return val1 > val2 ? val1 : val2;
		} else {
			return val1;
		}
	} else if (typeof val2 === 'number') {
		return val2;
	}
	return null;
}

export default class LookupListInput extends React.PureComponent {
	render() {
		let valueList = (this.props.value || EMPTY_LIST).filter(v => v !== null);
		if (!this.props.readOnly || (valueList.size === 0)) {
			valueList = valueList.concat(null);
		}
		return valueList.map((value, index) => {
			const isNew = index === (valueList.size - 1);
			return (
				<LookupInput
					key={index}
					value={value}
					onChange={value => {
						if (isNew) {
							this._autoFocusId = getNextAutoFocusId();
						}
						this.props.onChange(valueList.set(index, value).filter(v => !isEmpty(v)));
					}}
					className="ps-lookupAnchor"
					getRows={this.props.getRows}
					getText={this.props.getText}
					timeout={this.props.timeout}
					placeholder={this.props.placeholder}
					name={this.props.name}
					onBlur={this.props.onBlur}
					readOnly={this.props.readOnly}
					combo={this.props.combo}
					autoFocusId={maxNumber(this.props.autoFocusId, this._autoFocusId)}
					suppressItemAction={true}
					onSuppressedAction={(e, soft) => {
						if (!soft) {
							triggerActionEvent(e.target);
						}
					}}
				/>
			);
		});
	}
}

